import { useTranslation } from 'react-i18next';
import { Container, Panel, AppInfoContainer } from './Verification.style';
import backgroundImage from '../../assets/images/air_traffic_control_tower_sunset_small.png';
import VerificationPanel from './verificationPanel/VerificationPanel';

const Verification = () => {
  const { t } = useTranslation();

  return (
    <Container backgroundImage={backgroundImage}>
      <Panel>
        <AppInfoContainer>
            <h2><span style={{fontWeight:300}}>BHANSA</span> <span>RASPORED</span></h2>
        </AppInfoContainer>
        <VerificationPanel app="App" />
      </Panel>
    </Container>
  );
};

export default Verification; 